import * as React from 'react';

export function Professionalize() {
  return (
    <section className="edu-pro">
      <style>{`
        .edu-pro {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .edu-pro-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .edu-pro h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          text-align: center;
        }
        .edu-pro .subtitle {
          font-size: 16px;
          color: #666;
          text-align: center;
          margin: 0 0 40px;
        }
        .edu-pro-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }
        .edu-pro-card {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          background: #fff;
          border-radius: 12px;
          padding: 18px 20px;
          border: 1px solid #eee;
        }
        .edu-pro-card .card-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #f0fdf0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .edu-pro-card .card-icon i {
          font-size: 18px;
          color: #1EAA25;
        }
        .edu-pro-card-text h3 {
          font-size: 15px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 4px;
        }
        .edu-pro-card-text p {
          font-size: 14px;
          color: #666;
          line-height: 1.5;
          margin: 0;
        }
        .edu-pro .closing {
          text-align: center;
          font-size: 16px;
          color: #333;
          font-weight: 600;
          margin: 36px 0 0;
        }
        @media (max-width: 768px) {
          .edu-pro-cards {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .edu-pro h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="edu-pro-inner">
        <h2>Ordená el abastecimiento de tu institución</h2>
        <p className="subtitle">Menos tiempo gestionando proveedores, más tiempo educando.</p>

        <div className="edu-pro-cards">
          <div className="edu-pro-card">
            <div className="card-icon"><i className="fa fa-file-invoice" /></div>
            <div className="edu-pro-card-text">
              <h3>Facturación formal</h3>
              <p>Todas las compras en blanco, con factura A o B según tu condición fiscal.</p>
            </div>
          </div>
          <div className="edu-pro-card">
            <div className="card-icon"><i className="fa fa-calendar-check" /></div>
            <div className="edu-pro-card-text">
              <h3>Entrega programada</h3>
              <p>Elegí día y horario. El pedido llega cuando lo necesitás, sin sorpresas.</p>
            </div>
          </div>
          <div className="edu-pro-card">
            <div className="card-icon"><i className="fa fa-chart-simple" /></div>
            <div className="edu-pro-card-text">
              <h3>Control y trazabilidad</h3>
              <p>Historial completo de compras para auditorías, rendiciones y presupuestos.</p>
            </div>
          </div>
        </div>

        <p className="closing">Una institución organizada empieza por un abastecimiento organizado.</p>
      </div>
    </section>
  );
}
